import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Portfoliosdetailstopsection from "../components/Portfoliosdetailstopsection";
import Overviewsection from "../components/overviewsection";
import Technologysection from "../components/Technologysection";
import WebsiteFeaturesBanner from "../components/WebsiteFeaturesBanner";
import ContactForm from "../components/contact-form";
import okbajuLogo from "../images/okbaju-logo.png";
import storiseLogo from "../images/storise-logo.png";
import jobsetLogo from "../images/jobset-logo.png";
import desktopokbajuImg from "../images/comp/desktop-okbaju_1.webp";
import okbajuPortImg from "../images/comp/okbaju-port.webp";
import storisePortImg from "../images/comp/storise.webp";
import jobsetPortImg from "../images/comp/jobset.webp";

const PortfoliosdetailsPage = () => {
  const { id } = useParams();

  // All portfolio details data
  const allPortfoliosData = {
    okbaju: {
      portfolioData: {
        logoimage: okbajuLogo,
        title: "Home services at your doorstep",
        description:
          "We bring top-quality home services directly to you, making home maintenance easier than ever. Whether you need repairs, cleaning, or specialized assistance, our platform connects you with skilled professionals in your area.",
        buttontext: "Get a Quote",
        buttonlink: "/contact",
        image: desktopokbajuImg,
      },
      overviewData: {
        image: okbajuPortImg,
        title: "OkBaju – Project Overview",
        description: `OkBaju is a dynamic and customer-centric online fashion platform dedicated to delivering trendy, affordable, and high-quality clothing to a diverse audience. Designed with a modern aesthetic and seamless shopping experience, OkBaju aims to bridge the gap between style and accessibility for fashion-conscious individuals. Our platform features a wide range of apparel for men, women, and children, curated to reflect current fashion trends and everyday comfort. With a strong focus on local and regional fashion preferences, OkBaju supports both well-known and emerging designers, bringing unique styles directly to our customers' fingertips.`,
        buttontext: "Get a Quote",
        buttonlink: "/contact",
      },
      technologyData: {
        mainTitle: "Technology Stack",
        subTitle:
          "To bring the OkBaju platform to life, we thoughtfully chose a modern, reliable, and scalable technology stack. Each tool and framework was selected to deliver a smooth user experience, high performance, and long-term flexibility across both the website and mobile applications.",
        categories: [
          {
            title: "Frontend",
            items: [
              {
                label: "HTML5, CSS3, JavaScript",
                text: "Core web technologies for structure, styling, and interactivity.",
              },
              {
                label: "Blade (Laravel Templating Engine)",
                text: "For dynamic rendering of web pages and seamless integration with backend logic.",
              },
            ],
          },
          {
            title: "Backend",
            items: [
              {
                label: "PHP (Laravel Framework)",
                text: "A robust and scalable backend framework used to handle business logic,",
              },
              {
                label: "Node.js (optional services)",
                text: "Utilized for any real-time or event-driven features as needed.",
              },
            ],
          },
          {
            title: "Database",
            items: [
              {
                label: "MySQL",
                text: "A reliable relational database used to manage structured data such as products, users, and orders.",
              },
            ],
          },
          {
            title: "UI/UX Design",
            items: [
              {
                label: "Figma",
                text: "Used for wireframing and interface design to ensure a clean and intuitive user experience.",
              },
            ],
          },
        ],
      },
      WebsiteFeaturesData: {
        title: "OkBaju – Website Features & Admin Panel",
        description:
          "OkBaju is a single-vendor fashion e-commerce platform built to make online shopping easy, fast, and enjoyable. The website allows users to browse a curated catalog of clothing, view detailed product pages, and quickly add items to their cart. With features like secure login, personalized profiles, and a smooth checkout process, OkBaju ensures a seamless and user-friendly shopping experience.",
        image: okbajuPortImg,
        imageAlt: "OkBaju Website Features",
        websiteFeaturesTitle: "Website Features",
        websiteFeatures: [
          "Secure Login & User Profiles: Create an account, log in securely, and manage your profile information.",
          "Product Browsing & Search: Browse a curated catalog of clothing, view detailed product pages, and quickly add items to your cart.",
          "Detailed Product Pages: View detailed product pages with images, descriptions, and pricing information.",
          "Add to Cart & Wishlist: Add items to your cart and save your favorite items for later.",
          "Seamless Checkout Process: Checkout securely and conveniently with your preferred payment method.",
        ],
        adminPanelTitle: "Web Admin Panel Features",
        adminFeatures: [
          "Product Management: Add, edit, update, or remove products with ease.",
          "Order Management: Manage orders and track their status.",
          "User Management: Manage user accounts and permissions.",
          "Insights & Reports: View real-time analytics and insights to optimize your website performance.",
          "Notifications: Send updates, promotions, and important alerts to users instantly.",
        ],
      },
    },
    storise: {
      portfolioData: {
        logoimage: storiseLogo,
        title: "Read. Listen. Rise. All-in-One Streaming App",
        description:
          "Storise is a comprehensive streaming platform that brings together audio books, podcasts, and stories in one place. Designed to deliver an immersive listening experience with intuitive navigation and personalized content recommendations.",
        buttontext: "Get a Quote",
        buttonlink: "/contact",
        image: storisePortImg,
      },
      overviewData: {
        image: storisePortImg,
        title: "Storise – Project Overview",
        description: `Storise is an innovative streaming platform that revolutionizes how people consume audio content. Our platform features a wide range of content including audiobooks, podcasts, and original stories, curated to provide users with the best listening experience. With a strong focus on user engagement and content discovery, Storise supports both creators and listeners in a seamless ecosystem.`,
        buttontext: "Get a Quote",
        buttonlink: "/contact",
      },
      technologyData: {
        mainTitle: "Technology Stack",
        subTitle:
          "Storise is built on a modern, scalable technology stack designed to handle high volumes of streaming content and provide smooth user experiences across all devices.",
        categories: [
          {
            title: "Frontend",
            items: [
              {
                label: "React, HTML5, CSS3",
                text: "Modern frontend technologies for responsive and interactive user interfaces.",
              },
            ],
          },
          {
            title: "Backend",
            items: [
              {
                label: "Node.js, Express",
                text: "Scalable backend framework for handling API requests and content management.",
              },
            ],
          },
          {
            title: "Database",
            items: [
              {
                label: "MongoDB",
                text: "NoSQL database for flexible content storage and user data management.",
              },
            ],
          },
          {
            title: "UI/UX Design",
            items: [
              {
                label: "Figma",
                text: "Used for wireframing and interface design to ensure a clean and intuitive user experience.",
              },
            ],
          },
        ],
      },
      WebsiteFeaturesData: {
        title: "Storise – Platform Features",
        description:
          "Storise offers a comprehensive set of features designed to enhance the listening experience and provide seamless content discovery.",
        image: storisePortImg,
        imageAlt: "Storise Platform Features",
        websiteFeaturesTitle: "Website Features",
        websiteFeatures: [
          "Real Voices, Real Stories: Listen to a wide range of stories, podcasts, and audiobooks from a diverse collection of creators.",
          "Effortless Storytelling",
          "Interactive Features: Interact with the stories and podcasts with interactive features like voice recognition and text-to-speech.",
          "Multi-Genre Support: Discover stories and podcasts from a wide range of genres.",
          "Personalized Recommendations: Get personalized recommendations based on your listening history and preferences.",
        ],
        adminPanelTitle: "Web Admin Panel Features",
        adminFeatures: [
          "Content Management: Add, edit, update, or remove stories, podcasts, and audiobooks with ease.",
          "User Analytics: View real-time analytics and insights to optimize your platform performance.",
          "Subscription Management: Manage user subscriptions and billing.",
          "Creator Dashboard: Manage your content and track your earnings.",
          "Revenue Reports: View your revenue and earnings reports.",
        ],
      },
    },
    jobset: {
      portfolioData: {
        logoimage: jobsetLogo,
        title: "Explore our platform",
        description:
          "Jobset was designed to empower contractors like you, providing you with the tools you need to succeed. Connect with job opportunities, manage your profile, and grow your contracting business.",
        buttontext: "Get a Quote",
        buttonlink: "/contact",
        image: jobsetPortImg,
      },
      overviewData: {
        image: jobsetPortImg,
        title: "Jobset – Project Overview",
        description: `Jobset is a comprehensive job matching platform specifically designed for contractors and construction professionals. Our platform connects skilled contractors with relevant job opportunities, streamlining the hiring process for both contractors and employers. With advanced matching algorithms and intuitive features, Jobset empowers contractors to find the right opportunities and build successful careers.`,
        buttontext: "Get a Quote",
        buttonlink: "/contact",
      },
      technologyData: {
        mainTitle: "Technology Stack",
        subTitle:
          "Jobset leverages cutting-edge technology to provide fast, reliable job matching and seamless user experiences for contractors and employers.",
        categories: [
          {
            title: "Frontend",
            items: [
              {
                label: "React, JavaScript",
                text: "Modern frontend framework for responsive and dynamic user interfaces.",
              },
            ],
          },
          {
            title: "Backend",
            items: [
              {
                label: "Node.js, Express",
                text: "Robust backend infrastructure for job matching algorithms and user management.",
              },
            ],
          },
          {
            title: "Database",
            items: [
              {
                label: "MongoDB",
                text: "Flexible database solution for storing job listings, user profiles, and application data.",
              },
            ],
          },
          {
            title: "UI/UX Design",
            items: [
              {
                label: "Figma",
                text: "Used for wireframing and interface design to ensure a clean and intuitive user experience.",
              },
            ],
          },
        ],
      },
      WebsiteFeaturesData: {
        title: "Jobset – Platform Features",
        description:
          "Jobset provides comprehensive features to help contractors find opportunities and employers discover skilled professionals.",
        image: jobsetPortImg,
        imageAlt: "Jobset Platform Features",
        websiteFeaturesTitle: "Website Features",
        websiteFeatures: [
          "Instant Job Alerts: Get instant alerts when new job opportunities are posted.",
          "Smart Job Matching: Find the perfect job opportunity for you based on your skills and preferences.",
          "One-Tap Apply: Apply for a job with a single tap.",
          "Advanced Filters: Filter job opportunities by location, industry, and more.",
          "Profile Management: Manage your profile and your job applications.",
        ],
        adminPanelTitle: "Web Admin Panel Features",
        adminFeatures: [
          "Job Posting Management: Add, edit, update, or remove job opportunities with ease.",
          "Candidate Screening: Screen candidates for a job opportunity.",
          "Application Tracking: Track applications for a job opportunity.",
          "Analytics Dashboard: View real-time analytics and insights to optimize your platform performance.",
          "Notification System: Send updates, promotions, and important alerts to users instantly.",
        ],
      },
    },
  };

  // Get current portfolio data based on ID, default to okbaju if not found
  const currentPortfolio = allPortfoliosData[id] || allPortfoliosData.okbaju;

  const { portfolioData, overviewData, technologyData, WebsiteFeaturesData } =
    currentPortfolio;

  return (
    <div>
      <Header />

      <Portfoliosdetailstopsection
        logoimage={portfolioData.logoimage}
        title={portfolioData.title}
        description={portfolioData.description}
        buttontext={portfolioData.buttontext}
        buttonlink={portfolioData.buttonlink}
        image={portfolioData.image}
      />

      <Overviewsection
        image={overviewData.image}
        title={overviewData.title}
        description={overviewData.description}
        buttontext={overviewData.buttontext}
        buttonlink={overviewData.buttonlink}
      />
      <Technologysection
        mainTitle={technologyData.mainTitle}
        subTitle={technologyData.subTitle}
        categories={technologyData.categories}
      />
      <WebsiteFeaturesBanner
        title={WebsiteFeaturesData.title}
        description={WebsiteFeaturesData.description}
        image={WebsiteFeaturesData.image}
        imageAlt={WebsiteFeaturesData.imageAlt}
        websiteFeaturesTitle={WebsiteFeaturesData.websiteFeaturesTitle}
        websiteFeatures={WebsiteFeaturesData.websiteFeatures}
        adminPanelTitle={WebsiteFeaturesData.adminPanelTitle}
        adminFeatures={WebsiteFeaturesData.adminFeatures}
      />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default PortfoliosdetailsPage;
